export const GET_COOKIE = 'common/cookie/GET';
export const SET_COOKIE = 'common/cookie/SET';
export const STORE_COOKIE = 'common/cookie/STORE';

export default function reducer(state = {}, action = {}) {
    switch (action.type) {
      case STORE_COOKIE:
        return {
          ...state,
          [action.cookieName]: action.value
        };
    }

    return state;
}

export function getCookie(name, defaultValue = null) {
    return {
      type: GET_COOKIE,
      cookieName: name,
      defaultValue
    };
}

export function setCookie(name, value, options) {
    return {
      type: SET_COOKIE,
      cookieName: name,
      value,
      options
    };
}

export function storeCookie(name, value) {
    return {
      type: STORE_COOKIE,
      cookieName: name,
      value
    };
}


// WEBPACK FOOTER //
// ./modules/Common/reducers/cookies.js